import { Component } from 'react';
import styled from 'styled-components';
import { Badge } from '../Badge/Badge';
import { ButtonVariation } from '../Button/Button';
import { theme } from '../theme';

const TabElement = styled.div<Pick<IProps, 'selected' | 'hasIcon' | 'badgeLabel' | 'padding' | 'margin'>>`
  font-size: 1.6rem;
  line-height: 1.1875;
  padding: ${({ badgeLabel, padding }) => (badgeLabel ? '1.6rem 0' : padding ? padding : '1.95rem 0')};
  cursor: pointer;
  color: ${({ selected, theme }) => (selected ? theme.vars.newColor.darkGS1 : theme.vars.newColor.darkGS2)};
  font-weight: 600;
  border-bottom: 4px solid transparent;
  border-bottom-color: ${({ selected, theme }) => (selected ? theme.vars.newColor.darkGS1 : null)};
  margin: ${({ margin }) => (margin ? margin : '0 30px 0 0')};
  display: flex;
  align-items: center;
  flex-direction: ${({ hasIcon }) => (hasIcon ? 'column' : 'row')};

  svg {
    margin-bottom: ${({ hasIcon }) => (hasIcon ? '10px' : null)};
    width: ${({ hasIcon }) => (hasIcon ? '20px !important' : null)};
    height: ${({ hasIcon }) => (hasIcon ? '20px' : null)};
    path {
      fill: ${({ selected, theme }) => (selected ? theme.vars.newColor.darkGS1 : theme.vars.newColor.darkGS2)};
    }
  }

  &:hover {
    border-bottom-color: ${({ selected, theme }) =>
      selected ? theme.vars.newColor.darkGS1 : theme.vars.newColor.darkGS2};
  }
`;

const BadgeElement = styled.span`
  margin-left: 1.1rem;
  pointer-events: none;
  position: relative;
`;

export interface IProps extends IntrinsicProps {
  children?: any;
  tabId?: string;
  variation?: ButtonVariation;
  selected?: boolean;
  disabled?: boolean;
  badgeLabel?: string;
  hasIcon?: boolean;
  padding?: string;
  margin?: string;
  badgeVariation?: 'normal' | 'error' | 'success';
  onClick?: (e: any, tabId: string) => void;
}

export class Tab extends Component<IProps> {
  public static defaultProps: Pick<IProps, 'badgeVariation'> = {
    badgeVariation: 'normal',
  };

  public render() {
    const { tabId, selected, badgeLabel, hasIcon, padding, margin, onClick, ...props } = this.props;

    return (
      <TabElement
        role="tab"
        data-tabid={tabId}
        selected={selected}
        onClick={this.handleClick}
        badgeLabel={badgeLabel}
        hasIcon={hasIcon}
        padding={padding}
        margin={margin}
        {...props}
      >
        {this.props.children}
        {this.props.badgeLabel != null && (
          <BadgeElement>
            <Badge
              size="small"
              borderColor={
                this.props.badgeVariation === 'error' || this.props.badgeVariation === 'success'
                  ? null
                  : this.props.selected
                  ? theme.vars.newColor.lightGS2
                  : theme.vars.newColor.lightGS1
              }
              variation={this.props.selected ? 'basic' : 'outline'}
              color={
                this.props.badgeVariation === 'error'
                  ? theme.vars.newColor.red2
                  : this.props.badgeVariation === 'success'
                  ? theme.vars.newColor.green2
                  : null
              }
            >
              {this.props.badgeLabel}
            </Badge>
          </BadgeElement>
        )}
      </TabElement>
    );
  }

  private handleClick = event => {
    if (this.props.onClick) {
      this.props.onClick(event, this.props.tabId);
    }
  };
}
